// @ts-nocheck
/**
 * squadbox.ai API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Application role
 */
export type UserRole = 'member' | 'admin' | 'owner' | 'super_admin';

export const UserRole = {
    member: 'member' as UserRole,
    admin: 'admin' as UserRole,
    owner: 'owner' as UserRole,
    super_admin: 'super_admin' as UserRole
};

